{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "مفعل",
          "DISABLED": "معطّل"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "أرسلت بواسطة",
          "BOT": "رد آلي",
          "FROM": "من",
          "URL": "الرابط:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "إلغاء",
        "CREATE_BUTTON_TEXT": "إنشاء",
        "FORM": {
          "TITLE": {
            "LABEL": "العنوان",
            "PLACEHOLDER": "الرجاء إدخال عنوان الحملة",
            "ERROR": "العنوان مطلوب"
          },
          "MESSAGE": {
            "LABEL": "رسالة",
            "PLACEHOLDER": "الرجاء إدخال رسالة الحملة",
            "ERROR": "الرسالة مطلوبة"
          },
          "INBOX": {
            "LABEL": "اختر صندوق الوارد",
            "PLACEHOLDER": "اختر صندوق الوارد",
            "ERROR": "صندوق الوارد مطلوب"
          },
          "SENT_BY": {
            "LABEL": "أرسلت بواسطة",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "المرسل مطلوب"
          },
          "END_POINT": {
            "LABEL": "الرابط",
            "PLACEHOLDER": "الرجاء إدخال الرابط",
            "ERROR": "الرجاء إدخال عنوان رابط صالح",
            "URL_IS_REGEXP": "القيمة تعبير نمطي (regular expression)"
          },
          "TIME_ON_PAGE": {
            "LABEL": "الوقت في الصفحة (ثواني)",
            "PLACEHOLDER": "الرجاء إدخال الوقت",
            "ERROR": "الوقت في الصفحة مطلوب"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "تفعيل الحملة",
            "TRIGGER_ONLY_BUSINESS_HOURS": "تشغيل فقط خلال ساعات العمل"
          },
          "BUTTONS": {
            "CREATE": "إنشاء",
            "CANCEL": "إلغاء"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "مكتمل",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "إلغاء",
        "CREATE_BUTTON_TEXT": "إنشاء",
        "FORM": {
          "TITLE": {
            "LABEL": "العنوان",
            "PLACEHOLDER": "الرجاء إدخال عنوان الحملة",
            "ERROR": "العنوان مطلوب"
          },
          "MESSAGE": {
            "LABEL": "رسالة",
            "PLACEHOLDER": "الرجاء إدخال رسالة الحملة",
            "ERROR": "الرسالة مطلوبة"
          },
          "INBOX": {
            "LABEL": "اختر صندوق الوارد",
            "PLACEHOLDER": "اختر صندوق الوارد",
            "ERROR": "صندوق الوارد مطلوب"
          },
          "AUDIENCE": {
            "LABEL": "الجمهور",
            "PLACEHOLDER": "حدد أوسمة العملاء",
            "ERROR": "الجمهور مطلوب"
          },
          "SCHEDULED_AT": {
            "LABEL": "الوقت المجدول",
            "PLACEHOLDER": "الرجاء اختيار الوقت",
            "ERROR": "الوقت المجدول مطلوب"
          },
          "BUTTONS": {
            "CREATE": "إنشاء",
            "CANCEL": "إلغاء"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "هل أنت متأكد من الحذف?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف الحملة بنجاح",
        "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى."
      }
    }
  }
}
